export const tableHeadClass = `px-1.5 py-3 h-8 border border-gray-200 border-t-0 first:border-l-0 last:border-r-0`;

export const tableCellClass = `px-1.5 py-2 bg-gray-50 z-10 border border-gray-200 first:border-l-0 last:border-r-0`;
export const tableCellLastRowClass = `border-b-0`; 